module.exports = __webpack_public_path__ + "static/media/linkedin.e5dc12f5.svg";